"use client";

import { createContext } from "react";

import type { TtvLaunchAccessState } from "@/features/ttv/launchAccess/types";

// A server-rendered denial cannot be final until the browser has checked for a saved early-access link.
export const TtvLaunchAccessContext =
  createContext<TtvLaunchAccessState | null>(null);
